const SUPPORTED_UI_CHUNK_TYPES = new Set([
  "start",
  "text-start",
  "text-delta",
  "text-end",
  "reasoning-start",
  "reasoning-delta",
  "reasoning-end",
  "tool-input-start",
  "tool-input-delta",
  "tool-input-available",
  "tool-output-available",
  "tool-output-error",
  "finish",
]);

function isPlainObject(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

function isNonEmptyString(value) {
  return typeof value === "string" && value.trim().length > 0;
}

function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

function validateChunkByType(chunk) {
  const type = chunk.type;
  switch (type) {
    case "start":
      if (hasOwn(chunk, "messageId") && !isNonEmptyString(chunk.messageId)) {
        return "start.messageId must be a non-empty string when provided";
      }
      return null;

    case "text-start":
    case "text-end":
    case "reasoning-start":
    case "reasoning-end":
      if (!isNonEmptyString(chunk.id)) {
        return `${type}.id must be a non-empty string`;
      }
      return null;

    case "text-delta":
    case "reasoning-delta":
      if (!isNonEmptyString(chunk.id)) {
        return `${type}.id must be a non-empty string`;
      }
      if (typeof chunk.delta !== "string") {
        return `${type}.delta must be a string`;
      }
      return null;

    case "tool-input-start":
      if (!isNonEmptyString(chunk.toolCallId)) {
        return "tool-input-start.toolCallId must be a non-empty string";
      }
      if (!isNonEmptyString(chunk.toolName)) {
        return "tool-input-start.toolName must be a non-empty string";
      }
      return null;

    case "tool-input-delta":
      if (!isNonEmptyString(chunk.toolCallId)) {
        return "tool-input-delta.toolCallId must be a non-empty string";
      }
      if (typeof chunk.inputTextDelta !== "string") {
        return "tool-input-delta.inputTextDelta must be a string";
      }
      return null;

    case "tool-input-available":
      if (!isNonEmptyString(chunk.toolCallId)) {
        return "tool-input-available.toolCallId must be a non-empty string";
      }
      if (!isNonEmptyString(chunk.toolName)) {
        return "tool-input-available.toolName must be a non-empty string";
      }
      if (!hasOwn(chunk, "input")) {
        return "tool-input-available.input is required";
      }
      return null;

    case "tool-output-available":
      if (!isNonEmptyString(chunk.toolCallId)) {
        return "tool-output-available.toolCallId must be a non-empty string";
      }
      if (!hasOwn(chunk, "output")) {
        return "tool-output-available.output is required";
      }
      return null;

    case "tool-output-error":
      if (!isNonEmptyString(chunk.toolCallId)) {
        return "tool-output-error.toolCallId must be a non-empty string";
      }
      if (!isNonEmptyString(chunk.errorText)) {
        return "tool-output-error.errorText must be a non-empty string";
      }
      return null;

    case "finish":
      if (hasOwn(chunk, "finishReason") && typeof chunk.finishReason !== "string") {
        return "finish.finishReason must be a string when provided";
      }
      return null;

    default:
      return `unsupported chunk type: ${String(type)}`;
  }
}

export function validateUiChunkEnvelope(payload) {
  if (!isPlainObject(payload)) {
    return { ok: false, error: "ui_chunk payload must be an object" };
  }

  const streamVersion = payload.streamVersion;
  if (streamVersion !== undefined && streamVersion !== "v2") {
    return { ok: false, error: "ui_chunk streamVersion must be 'v2' when provided" };
  }

  if (!isPlainObject(payload.chunk)) {
    return { ok: false, error: "ui_chunk payload.chunk must be an object" };
  }

  const chunk = payload.chunk;
  if (!isNonEmptyString(chunk.type)) {
    return { ok: false, error: "ui_chunk payload.chunk.type must be a non-empty string" };
  }

  if (!SUPPORTED_UI_CHUNK_TYPES.has(chunk.type)) {
    return { ok: false, error: `ui_chunk payload.chunk.type is not supported: ${chunk.type}` };
  }

  const typeError = validateChunkByType(chunk);
  if (typeError) {
    return { ok: false, error: typeError };
  }

  return {
    ok: true,
    value: {
      streamVersion: streamVersion || "v2",
      chunk,
    },
  };
}
